// extracted by mini-css-extract-plugin
export default {"container":"VertiMallInfo_container__QKF2Q","mall_info":"VertiMallInfo_mall_info__QxJi2","hours_desc":"VertiMallInfo_hours_desc__o+hi8","lang":"VertiMallInfo_lang__ZLbJL"};